import { menuItem } from '@/components/SecondaryMenu';

export const MENU_ITEMS: menuItem[] = [
  { title: 'Financial', href: '/real-estate/financial-management' },
  { title: 'CRM', href: '/real-estate/customer-relationship-management' },
  { title: 'Leasing', href: '/real-estate/real-estate-lease-management' },
  { title: 'Utilities', href: '/real-estate/utilities-management' },
  {
    title: 'Shared Resources',
    href: '/real-estate/shared-resources-management',
  },
  { title: 'Supply Chain', href: '/real-estate/supply-chain-management' },
  {
    title: 'Maintenance',
    href: '/real-estate/building-asset-and-maintenance-management',
  },
  { title: 'Parking', href: '/real-estate/parking-management' },
  { title: 'Internet Portals', href: '/real-estate/internet-portals' },
  { title: 'Mobile Apps', href: '/real-estate/mobile-apps' },
  {
    title: 'Common Utilities',
    href: '#',
    items: [
      {
        title: 'Decision Support',
        href: '/real-estate/decision-support-modules',
        isActive: false,
      },
      {
        title: 'Application Configuration',
        href: '/real-estate/application-configuration-tools',
        isActive: false,
      },
    ],
  },
  {
    title: 'Interfaces',
    href: '/real-estate/application-programming-interfaces',
  },
];

//export default MENU_ITEMS;
